import React from "react";
import RecruiterLayerBlueprint from "components/blueprints/RecruiterLayerBlueprint";

function RecruiterSettingsProfilePage() {
  return <div>RecruiterSettingsProfilePage</div>;
}

export default RecruiterLayerBlueprint(RecruiterSettingsProfilePage);
